import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Ensure you have react-router-dom installed
import { useAuthStore } from '../../store';

import Success from '../../assets/images/auth/email-verified-success.png';
import Failed from '../../assets/images/auth/email-verified-failed.png';
import Loader from '../../components/base/loader';
import toast from 'react-hot-toast';
import BaseImage from '../../components/base/base-image';
import AppButton from '../../components/base/button';

const EmailVerification: React.FC = () => {
  const navigate = useNavigate();
  const { verifyEmail, resendVerificationEmail } = useAuthStore();

  // Retrieve the query parameters from the URL
  const searchParams = new URLSearchParams(window.location.search);
  // Extract the 'auth' parameter
  const auth = searchParams.get('auth');

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [verifiedState, setVerifiedState] = useState<string>('');

  const [resending, setResending] = useState<boolean>(false);
  const resendHandler = async () => {
    setResending(true);
    const response = await resendVerificationEmail(auth ? auth : '');
    if (response && response.isSuccess) {
      toast.success('Verification link resent successfully.');
    }
    setResending(false);
  };

  const handleLoginRedirect = () => {
    navigate('/login');
  };

  const verifyEmailHandler = async () => {
    if (!auth) {
      toast.error('Auth is missing');
    }

    setIsLoading(true);
    const response = await verifyEmail(auth);
    if (response) {
      setVerifiedState('verified');
    } else {
      setVerifiedState('not-verified');
    }
    setIsLoading(false);
  };

  useEffect(() => {
    verifyEmailHandler();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white email-verified-bg">
      {isLoading ? (
        <div className="mx-auto">
          <Loader width="5rem" borderTopColor="border-t-blue-500" />
        </div>
      ) : (
        <div className="max-w-md p-6 bg-transparent text-center">
          <div className="flex justify-center mb-4">
            <BaseImage
              imgSrc={verifiedState === 'verified' ? Success : Failed}
              imgAlt={
                verifiedState === 'verified'
                  ? 'Email verified'
                  : 'Email verification failed'
              }
              imgClass="mb-4 w-44"
            />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-6">
            {verifiedState === 'verified'
              ? 'Your email has been successfully verified'
              : 'Oops! Your email verification failed'}
          </h1>
          <div className="flex items-center gap-6">
            <AppButton
              label="Back to Login"
              type={verifiedState === 'verified' ? 'dark' : 'light'}
              clicked={handleLoginRedirect}
            />
            {verifiedState === 'not-verified' && (
              <AppButton
                label="Try Again"
                type="dark"
                clicked={verifyEmailHandler}
              />
            )}
          </div>

          {verifiedState === 'not-verified' ? (
            resending ? (
              <Loader
                className="mx-auto mt-6"
                width="1.5rem"
                borderTopColor="border-t-blue-500"
              />
            ) : (
              <p
                className="text-center text-primary text-sm font-semibold mt-6 cursor-pointer"
                onClick={resendHandler}
              >
                Resend Verification Link
              </p>
            )
          ) : null}
        </div>
      )}
    </div>
  );
};

export default EmailVerification;
